var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('CreditCard'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered is-size-7"},[_c('strong',[_vm._v("KUBOKTO SRL")]),_vm._v(" P.IVA 04500490406\n    ")])])
}]

export { render, staticRenderFns }